import React from 'react';
import {applyRouterMiddleware, browserHistory, Router, Route, Redirect, IndexRedirect } from 'react-router';
import { useScroll } from 'react-router-scroll';
import DashboardView from './../views/DashboardView/DashboardView.jsx';
import CourseList from './../course/CourseList/CourseList.jsx';
import CourseView from './../views/CourseView/CourseView.jsx';
import ProfileView from './../views/ProfileView/ProfileView.jsx';
import LectureView from './../views/LectureView/LectureView.jsx';
import Error404View from './../views/Error404View/Error404View.jsx';

export default () => {
  return (
    <Router history={ browserHistory } render={ applyRouterMiddleware(useScroll()) }>
      <Route component={ DashboardView } path="/">
        <IndexRedirect to="all" />
        <Route component={ ProfileView } path="/profile" />
        <Route component={ CourseList } path="/all" />
        <Route component={ CourseView } path="/course/:courseId" />
        <Route component={ LectureView } path="/lecture/:lectureId" />
        <Route component={ Error404View } path="/404" />
      </Route>
      <Redirect from='*' to="all" />
    </Router>
  );
};


/** WEBPACK FOOTER **
 ** ./src/js/routes/Private.jsx
 **/